import { styled } from '@mui/material/styles';
import { ReviewsEmptyIcon } from 'assets/images/icons';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const Container = styled('div')({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const Wrapper = styled('div')({
    '& svg': {
        display: 'block',
        margin: '0 auto 24px',
    },
});

const ReviewsNotSelected = ({ type }) => {
    const { t } = useTranslation();
    return (
        <Container>
            <Wrapper>
                <ReviewsEmptyIcon />
                <Typography
                    variant="h4"
                    sx={{ color: 'var(--primary-main)', marginBottom: '8px', textAlign: 'center' }}
                >
                    {t('ReviewsEmptyFeed.reviewsNotSelectedTitle')}
                </Typography>
                <Typography variant="body2" sx={{ color: 'var(--text-secondary)', textAlign: 'center' }}>
                    {t('ReviewsEmptyFeed.reviewsNotSelectedDescription', {
                        feedback:
                            type === 'feedback'
                                ? t('ReviewsEmptyFeed.surveyDescription')
                                : t('ReviewsEmptyFeed.integrationDescription'),
                    })}
                </Typography>
            </Wrapper>
        </Container>
    );
};

export default ReviewsNotSelected;
